import { Button } from "antd";
import TextArea, { TextAreaRef } from "antd/es/input/TextArea";
import React, { useEffect, useRef, useState } from 'react';
import { OpService } from "../../../util/services/operation";
import { zIndex } from "../../../util/varibles/constants";
import { showErrorResponse } from "../../../util/varibles/global";
import { TOperation } from "../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../util/varibles/message";
import Footer from "../_components/Footer";
import WrapperPopup, { openPopup } from "../_components/WrapperPopup";
import styles from './style.module.scss';

interface IOpenNote {
    title?: string
    note: string
    operation?: TOperation

    onSave(note: string): void

    onCancel?(): void
}

export function openNote(params: IOpenNote) {
    const { title, note, operation, onSave, onCancel } = params;
    const modalNode = openPopup(<PopupOpNote {...{
        isShow: true,
        info: title ? { code: title } : { code: 'Operation' },
        note: note.trim(),
        operation: operation ? operation : undefined,
        destroyOnHidden: true,
        handleSave: onSave,
        handleClose: () => {
            modalNode.remove();
            if (onCancel)
                onCancel();
        }
    }} />);
}

interface IProps {
    note?: string
    isShow: boolean
    info: any
    operation?: TOperation
    destroyOnHidden?: boolean

    handleSave(value: string): void

    handleClose?(): void
}



const PopupOpNote: React.FC<IProps> = (props) => {
    const { info, note = "", isShow = true } = props;

    const [state, setState] = useState({
        isShow,
        disabled: true,
        loading: false,
        value: note,
    })

    const inputRef = useRef<TextAreaRef>(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, [inputRef])

    useEffect(() => {
        setState(prev => ({ ...prev, isShow }))
    }, [isShow])

    const handleSave = () => {
        const note = state.value.trim();
        const { operation } = props;
        if (operation) {
            const { id, operation_code } = operation;
            setState(prev => ({ ...prev, loading: true }));
            OpService.updateNote({ note }, id)
                .then(() => {
                    notify.success(NotifyCode.S2)([`Note of #${operation_code}`]);
                    setState(prev => ({ ...prev, loading: false, isShow: false }));
                    props.handleSave(note);
                })
                .catch(error => {
                    setState(prev => ({ ...prev, loading: false }));
                    showErrorResponse('Update failed', error)
                })
        } else {
            props.handleSave(note);
            setState(prev => ({ ...prev, isShow: false }));
        }
    }

    const handleChange = (value: string) => {
        if (value.length <= 500)
            setState(prev => ({ ...prev, value }));
    }

    const handleClose = () => {
        setState(prev => ({ ...prev, isShow: false }));
        props.handleClose?.();
    }

    const { value = '', loading } = state;
    const { code } = info;

    return <WrapperPopup
        visible={state.isShow}
        className={styles.modal}
        title={`Note for ${code}`}
        onClose={handleClose}
        zIndex={zIndex.popupLev2}
    >
        <div className={styles.content}>
            <TextArea {...{
                className: 'scroll-small',
                ref: inputRef,
                rows: 4,
                value,
                onChange: ({ target }) => handleChange(target.value)
            }} />
            <div className='mt-10 text-comment'>{value.length}/500 characters</div>
        </div>
        <Footer className={styles.footer}>
            <Button
                className='bt-danger'
                onClick={() => handleChange("")}
                disabled={loading}
            >
                Delete
            </Button>
            <div className="flex gap-2">
                <Button className='bt-default' onClick={handleClose}>Cancel</Button>
                <Button
                    className='bt-primary'
                    onClick={handleSave}
                    loading={loading}
                >
                    Save
                </Button>
            </div>
        </Footer>
    </WrapperPopup>;
}

export default PopupOpNote;
